import Loading from './src/main';

export default {
  install (Vue, pluginOptions = {}) {
    const VueLoading = Vue.extend(Loading);
    let loading = null;

    // init
    function $loading () {
      return new Promise(resolve => {
        if (!loading) {
          loading = new VueLoading();
          // create
          loading.$mount();
          // mounte
          document.querySelector(pluginOptions.container || 'body').appendChild(loading.$el);
          loading.show();
          resolve();
        }
      });
    }
    $loading.close = () => {
      return new Promise(resolve => {
        if (!loading || !loading.visible) {
          resolve();
          return;
        }
        loading.close();
        loading = null;
      });
    };
    Vue.loading = Vue.prototype.$loading = $loading;
  }
};
